<div class="sx-metering-point__tab-content">
  <div class="sxl-align-right sxl-horizontal-stack-small">
  </div>

  <app-system-message 
    [isVisible]="true" 
    [isDismissable]="false" 
    [severity]="1" 
    [icon]="'#sx-info'" 
    [type]="3"
    [message]="'disruptions.disruption-info-banner-content-text'">
  </app-system-message>
  <section *ngFor="let customer of customersWithMeteringPointDisruptionsView" class="sx-metering-point__customer-section">

  <mat-expansion-panel [expanded]="customer._expanded" (opened)="panelOpened(customer)" (closed)="panelClosed(customer)">
    <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
      <mat-panel-title>
        <h2 class="h3 sx-metering-point__customer-heading">{{customer.name}}
          <span class="sxh-text-small">({{customer.id}})</span>
        </h2>
      </mat-panel-title>
    </mat-expansion-panel-header>

  
    <div class="sx-metering-point__wrapper">
      <div class="sxl-container">
        <div class="sxl-item sxl-item--4" *ngFor="let meteringPoint of customer.meteringPoints">
          <article class="sx-metering-point" [ngClass]="{'selected': meteringPoint.selected}">
            <div class="sx-metering-point__header--clickable sxl-grow" (click)="viewInformation(meteringPoint)">
              <header class="sx-metering-point__header sx-metering-point__content">
                <h3 class="sx-metering-point__heading">{{meteringPoint.name}}</h3>

                <div class="sxh-text-light"> {{ "disruptions.metering_point" | translate }} {{meteringPoint.id}}</div>
              </header>
                 
            <div class="sx-metering-point__content">
              <div class="sx-metering-point__content-row">
                <svg class="sxh-icon-big">
                  <use xlink:href="#sx-position" href="#sx-position" />
                </svg>
                <div class="sx-metering-point__row-fragment">
                  {{meteringPoint.addresses[0]!.street}} {{meteringPoint.addresses[0]!.streetNo}}
                  <br /> {{meteringPoint.addresses[0]!.zip}} {{meteringPoint.addresses[0]!.city | titlecase}}
                </div>
              </div>
              <div *ngFor="let disruptionInfo of meteringPoint.disruptionInfos">
              <div class="sx-metering-point__content-row">
                <div *ngIf="!disruptionInfo.isRestored && disruptionInfo.disturbanceType === DisturbanceTypeEnum.Delivery" matTooltip="{{'disruptions.delivery_disruption_tooltip' | translate}} " matTooltipClass="sx-metering-point__tooltip">
                  <svg class="sx-metering-point__planned-icon">
                    <use xlink:href="#baseline-warning-24px" href="#baseline-warning-24px" />
                  </svg>
                </div>
                <div *ngIf="!disruptionInfo.isRestored && disruptionInfo.isPlanned && disruptionInfo.disturbanceType !== DisturbanceTypeEnum.Delivery" matTooltip="{{'disruptions.planned_tooltip' | translate}} " matTooltipClass="sx-metering-point__tooltip">
                  <svg class="sx-metering-point__planned-icon">
                    <use xlink:href="#baseline-warning-24px" href="#baseline-warning-24px" />
                  </svg>
                </div>
                <div *ngIf="!disruptionInfo.isRestored && !disruptionInfo.isPlanned && disruptionInfo.disturbanceType !== DisturbanceTypeEnum.Delivery" matTooltip="{{'disruptions.unplanned_tooltip' | translate}} " matTooltipClass="sx-metering-point__tooltip">
                  <svg class="sx-metering-point__unplanned-icon">
                    <use xlink:href="#baseline-warning-24px" href="#baseline-warning-24px" />
                  </svg>
                </div>

                <div *ngIf="disruptionInfo.isRestored" matTooltip="{{'disruptions.restored_tooltip' | translate}} " matTooltipClass="sx-metering-point__tooltip">
                    <svg class="sx-metering-point__resolved-icon">
                      <use xlink:href="#baseline-warning-24px" href="#baseline-warning-24px" />
                    </svg>
                </div>
                <div class="sx-metering-point__row-fragment">
                  <span *ngIf="!disruptionInfo.isRestored && disruptionInfo.disturbanceType === DisturbanceTypeEnum.Delivery">
                    {{ "disruptions.ongoing-delivery-disruption" | translate }}
                  </span>
                  <span *ngIf="!disruptionInfo.isRestored && disruptionInfo.isPlanned && disruptionInfo.disturbanceType !== DisturbanceTypeEnum.Delivery">
                    {{ "disruptions.ongoing-planned-disruption" | translate }}
                  </span>
                  <span *ngIf="!disruptionInfo.isRestored && !disruptionInfo.isPlanned && disruptionInfo.disturbanceType !== DisturbanceTypeEnum.Delivery">
                    {{ "disruptions.ongoing-unplanned-disruption" | translate }}
                  </span>
                  <span *ngIf="disruptionInfo.isRestored && disruptionInfo.disturbanceType === DisturbanceTypeEnum.Delivery">
                    {{ "disruptions.restored-delivery-disruption" | translate }}
                  </span>
                  <span *ngIf="disruptionInfo.isRestored && disruptionInfo.isPlanned && disruptionInfo.disturbanceType !== DisturbanceTypeEnum.Delivery">
                    {{ "disruptions.restored-planned-disruption" | translate }}
                  </span>
                  <span *ngIf="disruptionInfo.isRestored && !disruptionInfo.isPlanned && disruptionInfo.disturbanceType !== DisturbanceTypeEnum.Delivery">
                    {{ "disruptions.restored-unplanned-disruption" | translate }}
                 </span>
                </div>
              </div>
              <div class="sx-metering-point__content-row">
                <svg>
                  <use xlink:href="#sx-avbrott" href="#sx-avbrott" />
                </svg>
                <div class="sx-metering-point__row-fragment" *ngIf="disruptionInfo.startTime">
                  {{ "disruptions.start_time_label" | translate }}
                  {{ disruptionInfo.startTime | date: 'HH:mm, d MMMM yyyy' }}
                </div>
              </div>
              <div class="sx-metering-point__content-row">
                <div></div>
                <div class="sx-metering-point__row-fragment" *ngIf="disruptionInfo.estimatedRestoreTime">
                  {{ "disruptions.restore_information_label_short" | translate }}
                  {{ disruptionInfo.estimatedRestoreTime | date: 'HH:mm, d MMMM yyyy' }}
                </div>
                <div class="sx-metering-point__row-fragment" *ngIf="!disruptionInfo.estimatedRestoreTime">
                  {{ "disruptions.restore_information_label_short_not_set" | translate }}
                </div>
              </div>
              </div>
            </div>
          </div>      
          </article>
        </div>
      </div>
    </div>
  </mat-expansion-panel >
  </section>
</div>